<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitEditPartner">

      <div class="form-group">
        <label for="legal_person">Наименование организации</label>
        <p id="legal_person" class="form-control form-control-sm">
            {{franchiseRelationName}})
        </p>
      </div>

      <div class="form-group">
        <label for="partnerData_fullName">Полное наименование (как в платежке)</label>
        <input
            id="partnerData_fullName"
            v-model="partnerData.full_name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.full_name.$error }"
        />
        <div v-if="submitted && $v.partnerData.full_name.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.full_name.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.partnerData.full_name.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.full_name.required.maxLength">
            {{$t('validatePhrases.maxLength')}}: 1023
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="partnerData_contractNumber">Номер договора</label>
        <input
            id="partnerData_contractNumber"
            v-model="partnerData.contract_number"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contract_number.$error }"
        />
        <div v-if="submitted && $v.partnerData.contract_number.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contract_number.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.partnerData.contract_number.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.contract_number.required.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="partnerData_contractDate">Дата договора</label>
        <input
            id="partnerData_contractDate"
            v-model="partnerData.contract_date"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.partnerData.contract_date.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contract_date.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.partnerData.contract_date.required.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person">Контактное лицо (полное ФИО)</label>
        <input
            id="contact_person"
            v-model="partnerData.contact_person"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_short_name">Контактное лицо (Фамилия и инициалы)</label>
        <input
            id="contact_person"
            v-model="partnerData.contact_person_short_name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_short_name.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_short_name.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_short_name.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_genitive">Контактное лицо в родительном падеже (полное ФИО)</label>
        <input
            id="contact_person_genitive"
            v-model="partnerData.contact_person_genitive"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_genitive.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_genitive.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_genitive.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_job_title">Должность контактного лица</label>
        <input
            id="contact_person_job_title"
            v-model="partnerData.contact_person_job_title"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_job_title.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_job_title.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_job_title.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_job_title_genitive">Должность контактного лица в родительном падеже</label>
        <input
            id="contact_person_job_title"
            v-model="partnerData.contact_person_job_title_genitive"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_job_title_genitive.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_job_title_genitive.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_job_title_genitive.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_phone">Номер телефона контактного лица</label>
        <input
            id="contact_person_phone"
            v-model="partnerData.contact_person_phone"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_phone.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_phone.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_phone.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="contact_person_email">Электронная почта контактного лица</label>
        <input
            id="contact_person_email"
            v-model="partnerData.contact_person_email"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.contact_person_email.$error }"
        />
        <div v-if="submitted && $v.partnerData.contact_person_email.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.contact_person_email.email">
            Некорректный email
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="legal_address">Юр адрес организации</label>
        <input
            id="legal_address"
            v-model="partnerData.legal_address"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.legal_address.$error }"
        />
        <div v-if="submitted && $v.partnerData.legal_address.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.legal_address.maxLength">
            {{$t('validatePhrases.maxLength')}}: 1023
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="inn">ИНН</label>
        <input
            id="inn"
            v-model="partnerData.inn"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.inn.$error }"
        />
        <div v-if="submitted && $v.partnerData.inn.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.inn.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.inn.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="kpp">КПП</label>
        <input
            id="kpp"
            v-model="partnerData.kpp"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.kpp.$error }"
        />
        <div v-if="submitted && $v.partnerData.kpp.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.kpp.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.kpp.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="ogrn">ОГРН(ИП)</label>
        <input
            id="ogrn"
            v-model="partnerData.ogrn"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.ogrn.$error }"
        />
        <div v-if="submitted && $v.partnerData.ogrn.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.ogrn.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.ogrn.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="registered_at">Дата регистрации организации</label>
        <input
            id="registered_at"
            v-model="partnerData.registered_at"
            type="date"
            class="form-control form-control-sm"
        />
        <div v-if="submitted && $v.partnerData.registered_at.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.registered_at.minLength">
            {{$t('validatePhrases.minLength')}}: 10
          </span>
          <span v-if="!$v.partnerData.registered_at.maxLength">
            {{$t('validatePhrases.maxLength')}}: 10
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="bank_bic">БИК</label>
        <input
            id="bank_bic"
            v-model="partnerData.bank_bic"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.bank_bic.$error }"
        />
        <div v-if="submitted && $v.partnerData.bank_bic.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.bank_bic.minLength">
            {{$t('validatePhrases.minLength')}}: 9
          </span>
          <span v-if="!$v.partnerData.bank_bic.maxLength">
            {{$t('validatePhrases.maxLength')}}: 9
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="bank_name">Название банка</label>
        <input
            id="bank_name"
            v-model="partnerData.bank_name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.bank_name.$error }"
        />
        <div v-if="submitted && $v.partnerData.bank_name.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.bank_name.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.bank_name.maxLength">
            {{$t('validatePhrases.maxLength')}}: 1023
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="bank_city">Город банка</label>
        <input
            id="bank_city"
            v-model="partnerData.bank_city"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.bank_city.$error }"
        />
        <div v-if="submitted && $v.partnerData.bank_city.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.bank_city.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.bank_city.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="corr_account">Корр счет</label>
        <input
            id="corr_account"
            v-model="partnerData.corr_account"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.corr_account.$error }"
        />
        <div v-if="submitted && $v.partnerData.corr_account.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.corr_account.minLength">
            {{$t('validatePhrases.minLength')}}: 20
          </span>
          <span v-if="!$v.partnerData.corr_account.maxLength">
            {{$t('validatePhrases.maxLength')}}: 20
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="current_account">Расчетный счет</label>
        <input
            id="current_account"
            v-model="partnerData.current_account"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.current_account.$error }"
        />
        <div v-if="submitted && $v.partnerData.current_account.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.current_account.minLength">
            {{$t('validatePhrases.minLength')}}: 20
          </span>
          <span v-if="!$v.partnerData.current_account.maxLength">
            {{$t('validatePhrases.maxLength')}}: 20
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="tax_mode">Налоговый режим</label>
        <input
            id="tax_mode"
            v-model="partnerData.tax_mode"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.tax_mode.$error }"
        />
        <div v-if="submitted && $v.partnerData.kpp.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.tax_mode.minLength">
            {{$t('validatePhrases.minLength')}}: 1
          </span>
          <span v-if="!$v.partnerData.tax_mode.maxLength">
            {{$t('validatePhrases.maxLength')}}: 255
          </span>
        </div>
      </div>

      <div class="form-group">
        <label for="with_nds">НДС</label>
        <input
            id="with_nds"
            v-model="partnerData.with_nds"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.partnerData.with_nds.$error }"
        />
        <div v-if="submitted && $v.partnerData.with_nds.$error" class="invalid-feedback">
          <span v-if="!$v.partnerData.with_nds.integer">
            НДС должен быть 0 или целым числом
          </span>
        </div>
      </div>

      <!-- 20/03/2026 попросили временно скрыть Метод расчета -->
<!--      <div class="form-group">-->
<!--        <label for="calc_method">Метод расчета</label>-->
<!--        <input-->
<!--            id="calc_method"-->
<!--            v-model="partnerData.calc_method"-->
<!--            type="text"-->
<!--            class="form-control form-control-sm"-->
<!--            :class="{ 'is-invalid': submitted && $v.partnerData.calc_method.$error }"-->
<!--        />-->
<!--        <div v-if="submitted && $v.partnerData.kpp.$error" class="invalid-feedback">-->
<!--          <span v-if="!$v.partnerData.calc_method.minLength">-->
<!--            {{$t('validatePhrases.minLength')}}: 1-->
<!--          </span>-->
<!--          <span v-if="!$v.partnerData.calc_method.maxLength">-->
<!--            {{$t('validatePhrases.maxLength')}}: 255-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->

      <div class="form-group">
        <div @click="selectReason" class="btn btn-sm btn-outline-info">
          Выбрать из справочника шаблонов <i class="fas fa-arrow-right"></i> и записать сюда <i class="fas fa-arrow-down"></i>
        </div>
        <label for="reason">Назначение платежа 1</label>
        <div id="reason" >
          <textarea
              v-model="partnerData.profit_payment_order_reason"
              rows="5"
              cols="100"
              class="form-control form-control-sm"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="reason_suffix">Назначение платежа 2</label>
        <div id="reason_suffix" >
          <textarea
              v-model="partnerData.profit_payment_order_reason_suffix"
              rows="1"
              cols="100"
              class="form-control form-control-sm"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="reason_suffix2">Назначение платежа 3</label>
        <div id="reason_suffix2" >
          <textarea
              v-model="partnerData.profit_payment_order_reason_suffix2"
              rows="1"
              cols="100"
              class="form-control form-control-sm"
          />
          <div @click="storeReason" class="btn btn-sm btn-outline-success">-->
            Записать это <i class="fas fa-arrow-up"></i> в <i class="fas fa-arrow-right"></i> справочник шаблонов
          </div>
          <p><br>Переменные, допустимые к использованию в назначении платежа:<br>
            <b><span style="color: darkmagenta">_NDS_</span></b> - Сформируется сумма НДС или фраза "НДС не облагается"<br>
            <b><span style="color: darkmagenta">_SUM_</span></b> - Сумма платежа<br>
            <b><span style="color: darkmagenta">_dd_mm_yyyy_START_</span></b> - Начало расчетного периода<br>
            <b><span style="color: darkmagenta">_dd_mm_yyyy_END_</span></b> - Окончание расчетного периода<br>
<!--            <b><span style="color: darkmagenta">_PERIOD_</span></b> - за периода с "месяц ГОД" по "месяц ГОД"<br>-->
            <b><span style="color: darkmagenta">_month_yyyy_START_PERIOD_</span></b> - "месяц ГОД" начала периода"<br>
            <b><span style="color: darkmagenta">_month_yyyy_END_PERIOD_</span></b> - "месяц ГОД" окончания периода"<br>
            <b><span style="color: darkmagenta">_CONTRACT_NUMBER_</span></b> - номер договора<br>
            <b><span style="color: darkmagenta">_CONTRACT_DATE_</span></b> - дата договора<br>
          </p>

        </div>
      </div>

      <div class="form-group">
        <label for="partner_status">Статус</label>
        <select
            id="partner_status"
            v-model="partnerData.status"
            class="form-control form-control-sm"
            @change = "onChangeStatus"
        >
          <option :key="1" :value="'active'">Активный</option>
          <option :key="2" :value="'inactive'">Деактивирован</option>
        </select>
      </div>

      <div class="form-group">
        <label for="description">Доп информация</label>
        <input
            id="description"
            v-model="partnerData.description"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

    </form>

    <popup
        :closeButton="selectOrderReason.closeButton"
        :show="selectOrderReason.show"
        :size="'lg'"
        @closePopup="closeSelectOrderReason"
    >
      <div slot="header">Создание платежного поручения</div>
      <div slot="body">
        <SelectOrderReason
            ref="myChildViewSelectOrderReason"
            @event-reason-was-selected="fillPartnerDataReason"
        >
        </SelectOrderReason>
      </div>
    </popup>

  </div>

</template>

<script>

import {integer, email, maxLength, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";
import Popup from "@/components/Popup.vue";
import SelectOrderReason from "@/components/management/partners/SelectOrderReason.vue";


import axios from "axios";
import ViewPartnerProfitOrder from "@/components/management/partners/ViewPartnerProfitOrder.vue";

export default {
  // mixins: [validationMixin],
  name: "EditPartner",
  components: {Popup, SelectOrderReason},
  data() {
    return {
      selectOrderReason: {
        show: false,
        // closeButton: null,
        // actionButton: null,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      franchiseRelationName: null,
      partnerData: {
        id: null,
        full_name: null,
        contract_number: null,
        contract_date: null,
        contact_person: null,
        contact_person_short_name: null,
        contact_person_genitive: null,
        contact_person_job_title: null,
        contact_person_job_title_genitive: null,
        contact_person_phone: null,
        contact_person_email: null,
        legal_address: null,
        inn: null,
        kpp: null,
        ogrn: null,
        registered_at: null,
        bank_bic: null,
        bank_city: null,
        bank_name: null,
        corr_account: null,
        current_account: null,
        tax_mode: null,
        with_nds: null,
        calc_method: null,
        profit_payment_order_reason: null,
        profit_payment_order_reason_suffix: null,
        profit_payment_order_reason_suffix2: null,
        status: null,
        description: null,
      },
      submitted: false
    }
  },
  mounted() {

  },
  props: {
    submitPartner: Number
  },
  watch: {
    submitPartner: function (val) {
      if (val > 0) {
        this.submitEditPartner();
      }
    },
  },
  computed: {

  },
  validations: {
    partnerData: {
      full_name: {required, minLength: minLength(1), maxLength: maxLength(1023)},
      contract_number: {required, minLength: minLength(1), maxLength: maxLength(255)},
      contract_date: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_short_name: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_genitive: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_job_title_genitive: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_job_title: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_phone: {minLength: minLength(1), maxLength: maxLength(255)},
      contact_person_email: {maxLength: maxLength(255)},
      // contact_person_email: {email},
      legal_address: {minLength: minLength(1), maxLength: maxLength(255)},
      inn: {minLength: minLength(1), maxLength: maxLength(255)},
      kpp: {minLength: minLength(1), maxLength: maxLength(255)},
      ogrn: {minLength: minLength(1), maxLength: maxLength(255)},
      registered_at: {minLength: minLength(1), maxLength: maxLength(255)},
      bank_bic: {minLength: minLength(9), maxLength: maxLength(9)},
      bank_city: {minLength: minLength(1), maxLength: maxLength(255)},
      bank_name: {minLength: minLength(1), maxLength: maxLength(1023)},
      corr_account: {minLength: minLength(20), maxLength: maxLength(20)},
      current_account: {minLength: minLength(20), maxLength: maxLength(20)},
      tax_mode: {minLength: minLength(1), maxLength: maxLength(255)},
      with_nds: {integer},
      calc_method: {minLength: minLength(1), maxLength: maxLength(255)},
    }
  },
  methods: {
    setNullFormData() {
      this.partnerData = {
        id: null,
        full_name: null,
        contract_number: null,
        contract_date: null,
        contact_person: null,
        contact_person_short_name: null,
        contact_person_genitive: null,
        contact_person_job_title: null,
        contact_person_job_title_genitive: null,
        contact_person_phone: null,
        contact_person_email: null,
        legal_address: null,
        inn: null,
        kpp: null,
        ogrn: null,
        registered_at: null,
        bank_bic: null,
        bank_city: null,
        bank_name: null,
        corr_account: null,
        current_account: null,
        tax_mode: null,
        with_nds: null,
        calc_method: null,
        profit_payment_order_reason: null,
        profit_payment_order_reason_suffix: null,
        profit_payment_order_reason_suffix2: null,
        status: null,
        description: null,
      };
    },
    getPartnerData(partnerId, partnerName) {
      this.franchiseRelationName = partnerName;
      axios
          .get(`/v1/partners/get?id=` + partnerId)
          .then(resp => {
                this.partnerData = resp.data;
              }
          )
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    saveEditPartner() {
      let formData = new FormData();

      for(let key in this.partnerData){
        if (this.partnerData[key] === null) {
          continue;
        }
        if( typeof this.partnerData[key] === 'object'){
          formData.append(key, JSON.stringify(this.partnerData[key]));
        }else{
          formData.append(key, this.partnerData[key]);
        }
      }

      axios
          .post(`/v1/partners/update`, formData)
          .then(resp => {
            this.$emit('partner-was-edited');
          }
          )
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;

      // this.submitted = true;
      // // stop here if form is invalid
      // this.$v.partnerData.$touch();
      // if (!this.$v.partnerData.$invalid) {
      //   this.$emit('partner-was-edited', this.partnerData);
      // }
    },
    selectReason() {
      this.$refs.myChildViewSelectOrderReason.getReasonData();
      this.selectOrderReason.show = true;
    },
    storeReason() {
      let formData = new FormData();
      formData.append('text', this.partnerData.profit_payment_order_reason);
      formData.append('suffix', this.partnerData.profit_payment_order_reason_suffix);
      formData.append('suffix2', this.partnerData.profit_payment_order_reason_suffix2);

        axios
            .post(`/v1/payment-order-reason-templates/set`, formData)
            .then(resp => {
                  alert('Новое назначение платежа добавлено в шаблоны');
                }
            )
            .catch(err => {
              this.$store.dispatch("addNotification", {
                text: err.response.data.message,
                time: 6,
                color: "danger"
              });
            })
        ;
    },
    closeSelectOrderReason() {
      this.selectOrderReason.show = false;
    },
    fillPartnerDataReason(selectedReason) {
      this.partnerData.profit_payment_order_reason = selectedReason.text;
      this.partnerData.profit_payment_order_reason_suffix = selectedReason.suffix;
      this.partnerData.profit_payment_order_reason_suffix2 = selectedReason.suffix2;
      this.closeSelectOrderReason();
    },
    onChangeFranchise () {
    },
    onChangeStatus() {
    },
    created() {

    }
  },
};
</script>

<style scoped lang="css">

</style>
